import Api from '../api'
export default ({

  state: {
    fiscalyearLists: []
  },
  mutations: {
    ADD_FISCAL_YEAR(state, fiscalyearLists) {
      let fiscalyearList = state.fiscalyearLists.concat(fiscalyearLists)
      state.fiscalyearLists = fiscalyearList
    },
    SET_FISCAL_LIST(state, fiscalyearList) {
      state.fiscalyearLists = fiscalyearList
    },
    DELETE_FISCAL_YEAR (state, fiscalYearId) {
      let fiscalYear = state.fiscalyearLists.filter(a => a.id !== fiscalYearId.id)
      state.fiscalyearLists = fiscalYear
    },
    UPDATE_FISCAL_YEAR(state, updateFiscalYear) {
      state.fiscalyearLists = state.fiscalyearLists.map(fiscalyear => fiscalyear.id !== updateFiscalYear.id ? fiscalyear : {...fiscalyear, ...updateFiscalYear})
    }
  },
  actions: {
    async createFiscalYear({ commit }, fiscalYear) {
      let response = await Api.request('post', '/fiscalYear/' + this.state.organisationid + '/' + this.state.user.id, fiscalYear)
      let savedFiscalYear = response.data.data
      if (response.data.status === 'SUCCESS') {
        commit('ADD_FISCAL_YEAR', savedFiscalYear)
      }
      return response
    },
    async loadFiscalYearList({ commit }) {
      let response = await Api.request('get', '/fiscalYear/' + this.state.organisationid)
      commit('SET_FISCAL_LIST', response.data.data)
      console.log(response)
      return response.data.data
    },
    async loadFiscalYearById({ commit }, fiscalYear) {
      let response = await Api.request('get', '/fiscalYear/fiscalYearById/' + this.state.organisationid + '/' + fiscalYear.id + '/' + this.state.user.id)
      // commit('ADD_FISCAL_YEAR', response.data.data)
      return response.data.data
    },
    async loadFiscalYearListDropDown({ commit }) {
      let response = await Api.request('get', '/fiscalYear/fiscalYearDropDownList/' + this.state.organisationid)
      commit('SET_FISCAL_LIST', response.data.data)
      console.log(response)
      return response.data.data
    },
    async deleteFiscalYear({commit}, fiscalYear) {
      let response = await Api.request('delete', '/fiscalYear/' + fiscalYear.fiscalYearId + '/' + this.getters.userId + '/' + fiscalYear.deleteReason)
      let fiscalyearLists = response.data.data
      if (response.data.status === 'SUCCESS') {
        commit('DELETE_FISCAL_YEAR', fiscalyearLists)
      }
      return response
    },
    async updateFiscalYear({commit}, fiscalYear) {
      let resp = await Api.request('put', '/fiscalYear/' + fiscalYear.id + '/' + this.getters.organisationId, fiscalYear)
      commit('UPDATE_FISCAL_YEAR', resp.data.data)
      return resp
    }
  },
  getters: {
  }
})



// WEBPACK FOOTER //
// ./src/store/fiscalYearMaster.js